import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow" }
const _hoisted_2 = { class: "px-4 py-5 sm:px-6 flex items-center gap-x-4" }
const _hoisted_3 = {
  type: "button",
  class: "inline-flex items-center gap-x-2 rounded-md bg-white px-2.5 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
}
const _hoisted_4 = { class: "h-5 w-5 shrink-0 text-gray-900 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_5 = { class: "text-base font-semibold leading-6 text-gray-900" }
const _hoisted_6 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_7 = { class: "px-4 py-5 sm:p-6 flex justify-between space-x-4" }
const _hoisted_8 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_9 = { class: "text-xl font-semibold mb-3" }
const _hoisted_10 = { class: "text-sm text-gray-600 mb-2" }
const _hoisted_11 = { class: "w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700 mb-4" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "text-gray-800 font-semibold" }
const _hoisted_14 = { class: "inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10" }
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "text-xs text-gray-600 mb-2" }
const _hoisted_17 = { class: "border border-gray-200 px-2 py-2 rounded-md flex items-center justify-between" }
const _hoisted_18 = { class: "text-xl font-semibold" }
const _hoisted_19 = { class: "flex items-center gap-x-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "px-4 py-4 sm:px-6 flex items-center gap-x-2 justify-end" }
const _hoisted_23 = { class: "flex items-center gap-x-2" }
const _hoisted_24 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_25 = {
  key: 1,
  class: "font-semibold"
}

import { License } from "@/interfaces/license.interface";
import { computed, ref } from "vue";
import { PlusIcon, MinusIcon } from "@heroicons/vue/20/solid";
import { useLearnerStore } from "@/stores/learnerStore";
import { groupBy } from "lodash";
import { Admin } from "@/interfaces/admin.interface";
import { useLicenseStore } from "@/stores/licenseStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseSeatsRequestComponent',
  props: {
    user: {},
    license: {}
  },
  emits: ["closeModal"],
  setup(__props: any, { emit }) {

const props = __props;

const licenseStore = useLicenseStore();
const learnerStore = useLearnerStore();





const additionalLicenses = ref(
  props.license.products.map((product) => ({
    product: product.product._id,
    additionalCount: 0,
  }))
);

const increase = (productId: string) => {
  const productLicense = additionalLicenses.value.find(
    (item) => item.product === productId
  );
  if (productLicense) {
    productLicense.additionalCount++;
  }
};

const decrease = (productId: string) => {
  const productLicense = additionalLicenses.value.find(
    (item) => item.product === productId
  );
  if (productLicense && productLicense.additionalCount > 0) {
    productLicense.additionalCount--;
  }
};

const learnersByGrade = computed(() => {
  const grouped = groupBy(learnerStore.schoolLearners, "grade");

  return Object.keys(grouped).map((grade) => {
    const filteredMaths = grouped[grade].filter((learner) => {
      return learner.classes.some((cls) => cls.subject.name === "Maths");
    });

    const filteredEnglish = grouped[grade].filter((learner) => {
      return learner.classes.some((cls) => cls.subject.name === "English");
    });

    return {
      level: parseInt(grade, 10),
      count: [filteredMaths.length, filteredEnglish.length],
    };
  });
});

const licenseProgress = computed(
  () => (product: any) =>
    Math.round((product.seatsUsed / product.maxSeats) * 100)
);

const submitRequest = async () => {
  const payload = {
    requestedBy: props.user ? props.user._id : "",
    additionalSeats: additionalLicenses.value.filter(
      (item) => item.additionalCount > 0
    ), // Only include products with requested licenses
  };

  if (payload && payload.additionalSeats.length > 0)
    await licenseStore.requestSeats(props.license._id, payload);
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_rl_icon, {
            icon: 'rl-menu',
            title: 'rl chat bubbles',
            "aria-hidden": "true"
          })
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("admin_overview_component.license_modal.request_license")), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("admin_overview_component.license_modal.license_requried")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.license.products, (product, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex-1 border border-gray-200 overflow-hidden bg-white shadow sm:rounded-lg"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", _hoisted_9, _toDisplayString(product.title), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(product.seatsUsed) + "/" + _toDisplayString(product.maxSeats) + " " + _toDisplayString(_ctx.$t("admin_overview_component.license_modal.used")), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "bg-blue-600 h-2 rounded-full",
                style: _normalizeStyle({ width: licenseProgress.value(product) + '%' })
              }, null, 4)
            ]),
            _createElementVNode("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learnersByGrade.value, (grade) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: grade.level,
                  class: "flex justify-between mb-2 text-[15px]"
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("admin_overview_component.license_modal.grade")) + " " + _toDisplayString(grade.level), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(grade.count[index]) + " " + _toDisplayString(_ctx.$t("admin_overview_component.license_modal.licenses")), 1)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("admin_overview_component.license_modal.how_many")), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h2", _hoisted_18, _toDisplayString(additionalLicenses.value.find(
                    (item) => item.product === product.product._id
                  )?.additionalCount), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (decrease(product.product._id)),
                    class: "rounded-md bg-white p-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  }, [
                    _createVNode(_unref(MinusIcon), {
                      class: "h-5 w-5",
                      "aria-hidden": "true"
                    })
                  ], 8, _hoisted_20),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (increase(product.product._id)),
                    class: "rounded-md bg-white p-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  }, [
                    _createVNode(_unref(PlusIcon), {
                      class: "h-5 w-5",
                      "aria-hidden": "true"
                    })
                  ], 8, _hoisted_21)
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeModal'))),
          type: "button",
          class: "rounded-md bg-white px-2.5 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
        }, _toDisplayString(_ctx.$t("admin_overview_component.license_modal.btn_cancel")), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (submitRequest())),
          type: "button",
          class: "rounded-md bg-[#155EEF] px-2.5 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#155EEF]"
        }, [
          (_unref(licenseStore).loader.requestingSeats)
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                _createVNode(_component_spinner_loader),
                _createTextVNode(" " + _toDisplayString(_unref(licenseStore).loadingMessage), 1)
              ]))
            : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("admin_overview_component.license_modal.submit")), 1))
        ])
      ])
    ])
  ]))
}
}

})